import citiesList from './actions/citiesList';
import createCity from './actions/createCity';
import getCity from './actions/getCity';
import updateCity from './actions/updateCity';
import getCities from './getters/getCities';
import uploadCities from './mutations/uploadCities';

const actions = {
    citiesList,
    updateCity,
    createCity,
    getCity
};

const mutations = {
    uploadCities
};

const getters = {
    getCities
};

export default { actions, mutations, getters };
